export default __webpack_public_path__ + "static/media/MainUnit-Gray-24x24.beaf93c8.svg";